import { AgentNotificationWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentNotificationWebService.Configuration
});

export default config;
